import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "live-app-design",
  "use": "live-app-design-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"live-app-design\"><path fill-rule=\"evenodd\" d=\"M4 20h16V4H4v16ZM4 2a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H4Zm5 5.5a1.5 1.5 0 1 0-2.999-.001A1.5 1.5 0 0 0 9 7.5ZM18 6l-5 5-2-2-5 5h12V6ZM8 17.822h8v-1.5H8v1.5Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol